

















































































import Vue from 'vue'
import moment from 'moment'
import {
  ABSENCES_ASSISTANT_GET_IS_EDITING_SERIE,
  ABSENCES_ASSISTANT_GET_PERIODICITY, ABSENCES_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST,
  ABSENCES_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST,
  GET_SELECTED_UI_LANGUAGE
} from '@/store/getter-types'
import {
  ABSENCES_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST,
  ABSENCES_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST,
} from '@/store/action-types'
import { Absence } from '@/model/absences/Absence'
import _ from 'lodash'
import { SelectedEmployee } from '@/model/absences/SelectedEmployee'
import { PlanningAssistantPeriodicityPayload } from '@/types/payload'
import { PeriodicityPlannedAbsenceEmployee } from '@/types'

interface EditableEmployee {
  id: number | undefined,
  name: string | undefined,
  medicalCertificate: boolean
  medicalCertificateValid: string
  comment: string
  detailId?: number
}

interface ComponentData {
  validUntilIso: string | undefined
  medicalCertificate: boolean
  comment: string
  editableEmployeeList: EditableEmployee[] | any
  panel: number[]
}

export default Vue.extend({
  name: 'AbsencesEditorAdditionalInformation',

  props: {
    editAdditionalInformation: Boolean,
    editAbsence: Object as () => Absence | undefined
  },

  data (): ComponentData {
    return {
      validUntilIso: undefined,
      medicalCertificate: false,
      comment: '',
      editableEmployeeList: [],
      panel: [0]
    }
  },

  computed: {
    plannedEmployeeList (): SelectedEmployee[] {
      return this.$store.getters[ABSENCES_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST]
    },

    plannedEditableEmployeeList (): Array<EditableEmployee> {
      const temporaryEmployees: Array<EditableEmployee> = []

      this.plannedEmployeeList.forEach((employee: SelectedEmployee) => {
        let isEmployeeCreated = false

        if (!isEmployeeCreated) {
          const editableEmployee: EditableEmployee = {
            id: employee.id,
            name: employee.name,
            medicalCertificate: employee.medicalCertificate,
            medicalCertificateValid: employee.medicalCertificateValid ? this.formatDateIso(employee.medicalCertificateValid) : '',
            comment: employee.comment,
          }
          temporaryEmployees.push(editableEmployee)
        }
      })
      this.editableEmployeeList = []
      this.editableEmployeeList = _.cloneDeep(temporaryEmployees)
      return this.editableEmployeeList
    },

    periodicityPlannedEmployeeList (): PeriodicityPlannedAbsenceEmployee[] {
      return this.$store.getters[ABSENCES_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST]
    },

    periodicityPlannedEditableEmployeeList (): PeriodicityPlannedAbsenceEmployee[] {
      this.editableEmployeeList = []
      this.editableEmployeeList = _.cloneDeep(this.periodicityPlannedEmployeeList.map((item: PeriodicityPlannedAbsenceEmployee) => {

        const temporaryEmployees: EditableEmployee[] = []
        let isEmployeeCreated = false

        if (!isEmployeeCreated) {
          item.employeeList.forEach((employee: SelectedEmployee) => {
            const editableEmployee: EditableEmployee = {
              id: employee.id,
              name: employee.name,
              medicalCertificate: employee.medicalCertificate,
              medicalCertificateValid: employee.medicalCertificateValid ? this.formatDateIso(employee.medicalCertificateValid) : '',
              comment: employee.comment,
              detailId: employee.detailId
            }
            temporaryEmployees.push(editableEmployee)
          })
        }

        return { date: item.date, employeeList: temporaryEmployees }
      }))

      return this.editableEmployeeList
    },

    selectedLocale(): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    periodicity (): PlanningAssistantPeriodicityPayload {
      return this.$store.getters[ABSENCES_ASSISTANT_GET_PERIODICITY]
    },

    isEditingSerie (): boolean {
      return this.$store.getters[ABSENCES_ASSISTANT_GET_IS_EDITING_SERIE]
    },
  },

  watch: {
    editAdditionalInformation (newVal: boolean): void {
      if(newVal) {
        setTimeout(() => {
          const focusedField: any = document.getElementById('focused1Field1')
          const focusedField2: any = document.getElementById('1focused1Field1')
          if (focusedField) {
            focusedField.focus()
          } else if (focusedField2) {
            focusedField2.focus()
          }

          this.$emit('changeEditAdditionalInformation')
        }, 0)
      }
    }
  },

  methods: {
    onKeyDown (event: any): void {
      if(this.periodicityPlannedEditableEmployeeList) {
        const index1: number = this.periodicityPlannedEditableEmployeeList.length
        let index2: number = 0
        if (this.periodicityPlannedEditableEmployeeList[index1 - 1] && this.periodicityPlannedEditableEmployeeList[index1 - 1].employeeList) {
          index2 = this.periodicityPlannedEditableEmployeeList[index1 - 1].employeeList.length
        }
        if (event.code === 'Tab' && !event.shiftKey && (this.periodicityPlannedEditableEmployeeList.length) > 0 && event.target && event.target.id === `3focused${index1}Field${index2}`) {
          this.$emit('goToNextStep')
        } else if (event.code === 'ArrowUp' && !event.shiftKey) {
          this.$emit('goToNextStep')
        }
      }
    },

    onKeyDown2 (event: any): void {
      if(event.code === 'Tab' && !event.shiftKey && (this.plannedEditableEmployeeList.length) > 0 &&  event.target && event.target.id === `focused3Field${this.plannedEditableEmployeeList.length}`) {
        this.$emit('goToNextStep')
      } else if(event.code === 'ArrowUp' && !event.shiftKey) {
        this.$emit('goToNextStep')
      }
    },

    formattedDate (date: string): string {
      return moment(date, 'DD.MM.YYYY').locale(this.selectedLocale).format('DD.MM.YYYY - dddd')
    },

    formatDate (date: Date): string {
      if(date) {
        return moment(date).format('DD.MM.YYYY')
      } else {
        return ''
      }
    },

    formatDateIso (date: Date): string {
      return moment(date).format('YYYY-MM-DD')
    },

    onFieldChange (employee: EditableEmployee): void {
      let employeeIndex: number = -1

      if(employee.medicalCertificateValid) {
        this.validUntilIso = this.formatDateIso(this.normalizeValidUntil(moment(employee.medicalCertificateValid).format("YYYY-MM-DD")))
      } else {
        this.validUntilIso = undefined
      }

      const localPlannedEmployeeList = _.cloneDeep(this.plannedEmployeeList)
      employeeIndex = _.findIndex(localPlannedEmployeeList, { id: employee.id })
      let updatedPlannedEmployee = localPlannedEmployeeList[employeeIndex!].updateMedicalCertificateValid(employee.medicalCertificateValid ? this.normalizeValidUntil(moment(employee.medicalCertificateValid).format("YYYY-MM-DD")) : undefined)

      if (employeeIndex !== -1) {
        localPlannedEmployeeList.splice(employeeIndex, 1, updatedPlannedEmployee)
        this.$store.dispatch(ABSENCES_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, localPlannedEmployeeList)
      }
    },

    onFieldChangePeriodicity (employee: EditableEmployee, idx: number): void {
      let employeeIndex: number = -1

      if(employee.medicalCertificateValid) {
        this.validUntilIso = this.formatDateIso(this.normalizeValidUntil(moment(employee.medicalCertificateValid).format("YYYY-MM-DD")))
      } else {
        this.validUntilIso = undefined
      }

      const localPlannedEmployeeList = _.cloneDeep(this.periodicityPlannedEmployeeList)
      employeeIndex = _.findIndex(localPlannedEmployeeList[idx].employeeList, { id: employee.id }) //check
      let updatedPlannedEmployee = localPlannedEmployeeList[idx].employeeList[employeeIndex!].updateMedicalCertificateValid(employee.medicalCertificateValid ? this.normalizeValidUntil(moment(employee.medicalCertificateValid).format("YYYY-MM-DD")) : undefined)

      if (employeeIndex !== -1) {
        localPlannedEmployeeList[idx].employeeList.splice(employeeIndex, 1, updatedPlannedEmployee)
        this.$store.dispatch(ABSENCES_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST, localPlannedEmployeeList)
      }
    },

    medicalCertificateChange (employee: EditableEmployee) {
      let employeeIndex: number = -1

      const localPlannedEmployeeList = _.cloneDeep(this.plannedEmployeeList)
      employeeIndex = _.findIndex(localPlannedEmployeeList, { id: employee.id })
      let updatedPlannedEmployee = localPlannedEmployeeList[employeeIndex!].updateMedicalCertificate(employee.medicalCertificate)

      if (employeeIndex !== -1) {
        localPlannedEmployeeList.splice(employeeIndex, 1, updatedPlannedEmployee)
        this.$store.dispatch(ABSENCES_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, localPlannedEmployeeList)
      }
    },

    medicalCertificateChangePeriodicity (employee: EditableEmployee, idx: number) {
      let employeeIndex: number = -1

      const localPlannedEmployeeList = _.cloneDeep(this.periodicityPlannedEmployeeList)
      employeeIndex = _.findIndex(localPlannedEmployeeList[idx].employeeList, { id: employee.id }) //check
      let updatedPlannedEmployee = localPlannedEmployeeList[idx].employeeList[employeeIndex!].updateMedicalCertificate(employee.medicalCertificate)
      if (employeeIndex !== -1) {
        localPlannedEmployeeList[idx].employeeList.splice(employeeIndex, 1, updatedPlannedEmployee)
        this.$store.dispatch(ABSENCES_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST, localPlannedEmployeeList)
      }
    },

    onCommentChange (employee: EditableEmployee): void {
      this.updateEmployeeComment(employee, false)
    },

    onCommentClear (employee: EditableEmployee): void {
      this.updateEmployeeComment(employee, true)
    },

    updateEmployeeComment (employee: EditableEmployee, isClearNoteEvent: boolean): void {
      let employeeIndex: number = -1

      const localPlannedEmployeeList = _.cloneDeep(this.plannedEmployeeList)
      employeeIndex = _.findIndex(localPlannedEmployeeList, { id: employee.id })
      let updatedPlannedEmployee = localPlannedEmployeeList[employeeIndex!].updateComment(isClearNoteEvent ? '' : employee.comment)

      if (employeeIndex !== -1) {
        localPlannedEmployeeList.splice(employeeIndex, 1, updatedPlannedEmployee)
        this.$store.dispatch(ABSENCES_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, localPlannedEmployeeList)
      }
    },

    onCommentChangePeriodicity (employee: EditableEmployee, idx: number): void {
      this.updateEmployeeCommentPeriodicity(employee, idx, false)
    },

    onCommentClearPeriodicity (employee: EditableEmployee, idx: number): void {
      this.updateEmployeeCommentPeriodicity(employee, idx, true)
    },

    updateEmployeeCommentPeriodicity (employee: EditableEmployee, idx: number, isClearNoteEvent: boolean): void {
      let employeeIndex: number = -1

      const localPlannedEmployeeList = _.cloneDeep(this.periodicityPlannedEmployeeList)
      employeeIndex = _.findIndex(localPlannedEmployeeList[idx].employeeList, { id: employee.id })
      let updatedPlannedEmployee = localPlannedEmployeeList[idx].employeeList[employeeIndex!].updateComment(isClearNoteEvent ? '' : employee.comment)

      if (employeeIndex !== -1) {
        localPlannedEmployeeList[idx].employeeList.splice(employeeIndex, 1, updatedPlannedEmployee)
        this.$store.dispatch(ABSENCES_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST, localPlannedEmployeeList)
      }
    },

    normalizeValidUntil (item: string): Date {
      const validUntil = item
      const hourStart = '23'
      const minuteStart = '59'
      const secondStart = '59'

      const dateStr = `${validUntil} ${hourStart.padStart(2, '0')}:${minuteStart.padStart(2, '0')}:${secondStart.padStart(2, '0')}`
      return moment(dateStr).toDate()
    },
  }

})
